module.exports = __webpack_public_path__ + "assets/img/enterprise1.d616b44b.png";